module.exports = __webpack_public_path__ + "static/media/logo.b08f2bf4.png";